<template>
  <div class="container">
    <h4 class="cardD">Entrega de información base</h4>
  </div>
</template>

<script>
export default {
  name: "InfoBase",
};
</script>
